define('Office_retail.ei1.Main.Model',
[
    'SCModel',
    'Utils'
],
function
(
    SCModelModule,
    Utils
) {
    'use strict';
 
    var SCModel = SCModelModule.SCModel;
 
    function OfficeRetailModel () {
        SCModel.call(this);
 
        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "Modules/Main/SuiteScript2/Office_retail.ei1.Main.Service.ss"
                ), true
            )
        }
    }
 
    OfficeRetailModel.prototype = Object.create(SCModel.prototype);
    OfficeRetailModel.prototype.constructor = OfficeRetailModel;
 
    return OfficeRetailModel
})
